function updatePrice(form) {
  const price = Number(form.dataset.productPrice || 0);
  const qtyInput = form.querySelector('.jc-js-quantity-selector');
  const qty = Number(qtyInput ? qtyInput.value : 0);

  const itemTotal = ((price * qty) / 100).toFixed(2);

  const totalEl = form.querySelector('.money-inner-total');
  if (totalEl) {
    totalEl.textContent = itemTotal;
  }

  updateCartTotal();
}

function updateCartTotal() {
  let cartTotal = 0;

  document.querySelectorAll('.quick-order-form').forEach((form) => {
    const price = Number(form.dataset.productPrice || 0);
    const qtyInput = form.querySelector('.jc-js-quantity-selector');
    const qty = Number(qtyInput ? qtyInput.value : 0);

    cartTotal += price * qty;
  });

  const cartPrice = document.querySelector('#jc-cart-price');
  if (cartPrice) {
    cartPrice.textContent = (cartTotal / 100).toFixed(2);
  }
}

document.addEventListener('click', function (e) {
  const downBtn = e.target.closest('.qty-btn-product-down, .jc-quantity-btn-down');

  if (downBtn) {
    e.preventDefault();

    const wrapper = downBtn.closest('.jc-product-quantity-wrapper');
    if (!wrapper) return;

    const step = Number(wrapper.dataset.qtyStep || 1);
    const input = wrapper.querySelector('.jc-js-quantity-selector');
    if (!input) return;

    const currentQty = Number(input.value || 0);
    const newQty = Math.max(0, currentQty - step);

    input.value = newQty;

    const form = downBtn.closest('.quick-order-form');
    if (form) {
      updatePrice(form);
    }

    return;
  }

  const upBtn = e.target.closest('.qty-btn-product-up');

  if (upBtn) {
    e.preventDefault();

    const wrapper = upBtn.closest('.jc-product-quantity-wrapper');
    if (!wrapper) return;

    const step = Number(wrapper.dataset.qtyStep || 1);
    const input = wrapper.querySelector('.jc-js-quantity-selector');
    if (!input) return;

    const currentQty = Number(input.value || 0);
    input.value = currentQty + step;

    const form = upBtn.closest('.quick-order-form');
    if (form) {
      updatePrice(form);
    }

    return;
  }

  const addSelectedBtn = e.target.closest('#jc-add-selected-to-cart');

  if (addSelectedBtn) {
    e.preventDefault();

    const items = [];

    document.querySelectorAll('.quick-order-form').forEach((form) => {
      const qtyInput = form.querySelector('.jc-js-quantity-selector');
      const qty = Number(qtyInput ? qtyInput.value : 0);

      if (qty > 0) {
        const variantSelect = form.querySelector('select[name="id"]');
        const sellingPlanSelect = form.querySelector('select[name="selling_plan"]');

        const variantId = variantSelect ? variantSelect.value : null;
        const sellingPlan = sellingPlanSelect ? sellingPlanSelect.value : null;

        if (!variantId) return;

        const item = {
          id: Number(variantId),
          quantity: qty
        };

        if (sellingPlan) {
          item.selling_plan = Number(sellingPlan);
        }

        items.push(item);
      }
    });

    if (!items.length) {
      alert('Please select at least one product.');
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items })
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(
              data.description || data.message || 'Unable to add items to cart.'
            );
          });
        }

        return response.json();
      })
      .then(() => {
        window.location.href = '/cart';
      })
      .catch((error) => {
        console.error(error);
        alert('Something went wrong adding your selected products to the cart.');
      });
  }
});